<script setup>
import { swalError, swalSuccess } from '@/helper';
import { delete_faq, get_faqs } from '@/services/faqs';
import { get_terms } from '@/services/terms';
import { onMounted, ref } from 'vue';

const faqs = ref([])
const isLoading = ref(true)
onMounted(async()=>{
  await retrieve_faqs()
  await get_categories()  
})

async function retrieve_faqs(){
  let response = await get_faqs()
  isLoading.value = false
  if (response.error){
    Swal.fire({
      title: 'Error',
      text: response.result.error,
      icon: 'error'
    })
    return
  }
  faqs.value = response.result.data.data
}

const categories = ref([])
async function get_categories(){
  let response = await get_terms('faq_category', {exist: true, name: 'faq'})
  if (response.error){
    Swal.fire({
      title: 'Error',
      text: response.result.error,
      icon: 'error'
    })
    return
  }
  categories.value = parse_category(response.result.data.term, response.result.data.term_relationship)
}

function parse_category(term, term_relationship){
  term = term.data.map(item => {
    let tempTaxom = term.included.find(taxom => taxom.attributes.term_id == item.id)
    let filteredFaq = term_relationship.data.filter(x => x.attributes.term_taxonomy_id == tempTaxom.id)
    filteredFaq = filteredFaq.map(i => i.attributes.object_id)
    return {
      ...item.attributes,
      term_taxonomy: {...tempTaxom},
      object_list: filteredFaq  
    }
  })
  return term
}

function get_cat_name(faq_id){
  let cat_name = ''
  categories.value.forEach(cat => {
    let isFound = cat.object_list.find(item => item == faq_id)
    if (isFound){
      return cat_name = cat.name
    }
  })
  return cat_name
}

async function deleteFaq(faq_id){
  let response = await delete_faq(faq_id)
  if (response.error){
    swalError(response.result.error, true)
    return
  }
  swalSuccess('Faq has been deleted')
  faqs.value = faqs.value.filter(item => item.id !== faq_id)
}
</script>

<template>
  <Breadcrumbs main="Faq Module"/>
  
  <div class="container-fluid">
    <div class="row">
      <!-- Page Title -->
      <div class="card">
        <div class="card-body">
          <div class="d-flex align-items-center justify-content-between">
            <h4 class="mb-0">FAQ List</h4>
            <router-link :to="{name: 'new-faq'}" class="btn btn-light-primary">
              Add FAQ
            </router-link>
          </div>
        </div>
      </div>
      
      <!-- Item List -->
      <template v-if="faqs == 0">
        <emptyCard :link="{
            routerObj: {name: 'new-faq'},
            type: 'link', desc: 'Add Faq', class: 'w-25'
        }" />
      </template>
      <template v-else>
        <div v-auto-animate v-for="faq in faqs" class="mb-1">
          <div class="col-md-12">
            <div class="card mb-1">
              <div class="card-body py-3">
                <div class="row">
                  <div class="col-6 my-auto">
                    <p class="text-truncate">{{ faq.attributes.title }}</p>
                  </div>
                  <div class="col-3">
                    <div class="rounded-pill bg-body-secondary text-center p-2">
                      <p>{{ get_cat_name(faq.id) }}</p>
                    </div>
                  </div>
                  <div class="col-3 d-flex justify-content-end align-items-center">
                    <router-link class="btn btn-light-warning icon-btn me-1"
                      :to="{name: 'edit-faq', params: {id: faq.id}}"
                    >
                      <vue-feather type="edit-2" size="1rem" />
                    </router-link>
                    <button class="btn btn-light-danger icon-btn" @click="deleteFaq(faq.id)">
                      <vue-feather type="trash" size="1rem" />
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </template>
    </div>
  </div>
</template>